'use client'
import { __awaiter } from '../../../../../../_virtual/_tslib.js';
import { FetchService } from '@dynamic-labs/utils';
import { dynamicEvents } from '../../../../events/dynamicEvents.js';
import '@dynamic-labs/sdk-api-core';
import { logger } from '../../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import '../../../../context/ViewContext/ViewContext.js';
import 'react';
import '@dynamic-labs/wallet-book';
import '../../../constants/colors.js';
import '../../../constants/values.js';
import '../../../../store/state/loadingAndLifecycle.js';
import '../../../../shared/consts/index.js';

const CONNECT_URL = 'https://relay.farcaster.xyz/v1/channel';
const STATUS_URL = 'https://relay.farcaster.xyz/v1/channel/status';
const STATUS_TIMEOUT = 300000;
const STATUS_INTERVAL = 1000;
const connect = (connectRequest) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield FetchService.fetch(CONNECT_URL, {
            body: JSON.stringify(connectRequest),
            headers: {
                'Content-Type': 'application/json',
            },
            method: 'POST',
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return yield response.json();
    }
    catch (error) {
        logger.error('Error connecting with farcaster:', error);
        return;
    }
});
const status = (connectStatusRequest) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield FetchService.fetch(STATUS_URL, {
            headers: {
                Authorization: `Bearer ${connectStatusRequest.channelToken}`,
                'Content-Type': 'application/json',
            },
            method: 'GET',
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return yield response.json();
    }
    catch (error) {
        logger.error('Error fetching farcaster connect status:', error);
        return;
    }
});
const watchStatus = (connectStatusRequest_1, ...args_1) => __awaiter(void 0, [connectStatusRequest_1, ...args_1], void 0, function* (connectStatusRequest, { timeout = STATUS_TIMEOUT, interval = STATUS_INTERVAL } = {}) {
    const deadline = Date.now() + timeout;
    let shouldPoll = true;
    let storedResolve = undefined;
    // When we cancel, immediately resolve the current timeout promise and abort status watch
    dynamicEvents.on('farcasterConnectCancelled', () => {
        shouldPoll = false;
        storedResolve === null || storedResolve === void 0 ? void 0 : storedResolve();
        storedResolve = undefined;
    });
    // Declaring the promise callback outside of loop to avoid unnecessary garbage generation
    const timeoutCallback = (resolve) => {
        storedResolve = resolve;
        setTimeout(resolve, interval);
    };
    while (shouldPoll && Date.now() < deadline) {
        const response = yield status(connectStatusRequest);
        if (!response) {
            return 'rejected';
        }
        if (response.state === 'completed') {
            return response;
        }
        yield new Promise(timeoutCallback);
    }
    if (!shouldPoll) {
        return 'cancelled';
    }
    logger.error(`Polling farcaster connect status timed out after ${STATUS_TIMEOUT}ms`);
    return 'timeout';
});

export { connect, status, watchStatus };
